<template>
  <div>
    <v-container fluid class="pa-1">
      <v-layout row justify-end wrap>
        <v-flex xs6>
          <v-text-field
            v-model="search"
            solo
            color="primary"
            append-icon="mdi-magnify"
            :label="$t('Search')"
            @click:append="getEntities"
            @keypress.enter="getEntities"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid class="pa-1" v-if="hasCriteriaFields">
      <v-layout row justify-end wrap>
        <v-flex v-for="(field, i) in criteriaConfig.fields" :key="i" v-bind="field.attrs">
          <input v-if="field.type == 'hidden'" type="hidden" v-model="criteria[field.name]" />

          <v-text-field
            v-if="field.type == 'text'"
            v-bind="getFieldAttrs(field)"
            v-model="criteria[field.name]"
            @keypress.enter="getEntities"
            :class="getFieldClass(field)"
            :label="$t(field.label)"
            solo
          ></v-text-field>

          <v-select
            v-if="field.type == 'select'"
            v-model="criteria[field.name]"
            :items="field.options"
            :label="field.label"
            clearable
            item-text="label"
            item-value="value"
            solo
          ></v-select>

          <aru-date-picker
            v-if="field.type == 'date'"
            v-bind="getFieldAttrs(field)"
            v-model="criteria[field.name]"
            @input="$emit('input', criteria)"
            :class="getFieldClass(field)"
            :label="$t(field.label)"
          ></aru-date-picker>

          <aru-time-picker
            v-if="field.type == 'time'"
            v-bind="getFieldAttrs(field)"
            v-model="criteria[field.name]"
            @input="$emit('input', criteria)"
            :class="getFieldClass(field)"
            :label="$t(field.label)"
          ></aru-time-picker>

          <aru-month-picker
            v-if="field.type == 'month-picker'"
            v-bind="getFieldAttrs(field)"
            v-model="criteria[field.name]"
            :class="getFieldClass(field)"
            :label="$t(field.label)"
          ></aru-month-picker>

          <aru-year-month-picker
            v-if="field.type == 'year-month-picker'"
            v-bind="getFieldAttrs(field)"
            v-model="criteria[field.name]"
            :class="getFieldClass(field)"
            :label="$t(field.label)"
          ></aru-year-month-picker>

          <og-user-select
            v-if="field.type == 'user-select'"
            multiple
            v-model="criteria[field.name]"
          ></og-user-select>
          <aru-entity-select
            v-if="field.type == 'entity-select' && field.entity"
            v-model="criteria[field.name]"
            :entity="field.entity"
            v-bind="getFieldAttrs(field)"
            :inputCssClass="getFieldClass(field)"
            solo
          ></aru-entity-select>
          <category-select
            v-if="field.type == 'category-select'"
            v-model="criteria[field.name]"
          ></category-select>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid class="pa-1" v-if="hasConstraintFields">
      <v-layout row justify-end wrap>
        <v-flex v-for="(field, i) in constraintConfig.fields" :key="i" v-bind="field.attrs">
          <input v-if="field.type == 'hidden'" type="hidden" v-model="constraint[field.name]" />

          <v-text-field
            v-if="field.type == 'text'"
            v-bind="getFieldAttrs(field)"
            v-model="constraint[field.name]"
            @keypress.enter="getEntities"
            :class="getFieldClass(field)"
            :label="$t(field.label)"
            solo
          ></v-text-field>

          <v-select
            v-if="field.type == 'select'"
            v-model="constraint[field.name]"
            :items="field.options"
            :label="field.label"
            clearable
            multiple
            item-text="label"
            item-value="value"
            solo
          >
            <template slot="selection" slot-scope="{ item, index }">
              <span v-if="constraint[field.name].length === 1">
                {{ item.label | truncate(30, '...') }}
              </span>
              <span v-if="index === 1">
                {{ constraint[field.name].length }} {{ $t('elementos') }}
              </span>
            </template>
          </v-select>

          <aru-date-picker
            v-if="field.type == 'date'"
            v-bind="getFieldAttrs(field)"
            v-model="constraint[field.name]"
            @input="$emit('input', constraint)"
            :class="getFieldClass(field)"
            :label="$t(field.label)"
          ></aru-date-picker>

          <aru-time-picker
            v-if="field.type == 'time'"
            v-bind="getFieldAttrs(field)"
            v-model="constraint[field.name]"
            @input="$emit('input', constraint)"
            :class="getFieldClass(field)"
            :label="$t(field.label)"
          ></aru-time-picker>

          <aru-month-picker
            v-if="field.type == 'month-picker'"
            v-bind="getFieldAttrs(field)"
            v-model="constraint[field.name]"
            :class="getFieldClass(field)"
            :label="$t(field.label)"
          ></aru-month-picker>

          <aru-year-month-picker
            v-if="field.type == 'year-month-picker'"
            v-bind="getFieldAttrs(field)"
            v-model="constraint[field.name]"
            :class="getFieldClass(field)"
            :label="$t(field.label)"
          ></aru-year-month-picker>

          <og-user-select
            v-if="field.type == 'user-select'"
            multiple
            v-model="constraint[field.name]"
          ></og-user-select>
          <aru-entity-select
            v-if="field.type == 'entity-select' && field.entity"
            v-model="constraint[field.name]"
            :entity="field.entity"
            v-bind="getFieldAttrs(field)"
            :inputCssClass="getFieldClass(field)"
            solo
          ></aru-entity-select>
          <category-select
            v-if="field.type == 'category-select'"
            v-model="constraint[field.name]"
          ></category-select>
        </v-flex>
      </v-layout>
    </v-container>

    <v-progress-linear
      v-if="loading && withProgressBar"
      class="py-0 my-0"
      height="3"
      :indeterminate="true"
    ></v-progress-linear>
  </div>
</template>

<script>
import AruDatePicker from '@/components/commons/form/inputs/AruDatePicker.vue';
import AruTimePicker from '@/components/commons/form/inputs/AruTimePicker.vue';
import AruYearMonthPicker from '@/components/commons/form/inputs/AruYearMonthPicker.vue';

import AruMonthPicker from '@/components/commons/form/inputs/AruMonthPicker.vue';
import AruSearchMixin from '@/mixins/search/AruSearchMixin.js';
import OgUserSelect from '@/components/commons/form/inputs/OgUserSelect';
import AruEntitySelect from '@/components/commons/form/inputs/AruEntitySelect.vue';

import CategorySelect from '../CategorySelect.vue';
export default {
  mixins: [AruSearchMixin],
  components: {
    OgUserSelect,
    CategorySelect,
    AruEntitySelect,
    AruDatePicker,
    AruTimePicker,
    AruMonthPicker,
    AruYearMonthPicker,
  },
};
</script>

<style></style>
